var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-arrow-container"},[_c('span',{staticClass:"text-arrow-text"},[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"text-arrow-image",attrs:{"alt":_vm.image_alt,"src":_vm.image_src}})])}
var staticRenderFns = []

export { render, staticRenderFns }